import React, { useContext } from 'react';
import { Icon } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import EnvironmentContext from '../../../../contexts/EnvironmentContext';
import PopupLink from '../PopupLink/PopupLink';

import { TListing } from 'types/TListing';

import Classes from './Report.scss';

type TReportProps = {
  itemId: TListing['itemId'];
  stats: TListing['stats'];
};

const Report = ({ itemId, stats }: TReportProps) => {
  const { t, date } = useI18nContext();
  const { favoritedCount, viewCount, since } = stats;
  const { userDetails: { isAdOwner = false } = {} } = useContext(EnvironmentContext);

  return (
    <div
      className={`block-wrapper-s ${Classes.container} ${Classes.moreStats}`}
      aria-label={`${t('stats.viewed', { viewCount })} ${t('stats.favorited', { favoritedCount })} ${t('stats.since').concat(date(new Date(since), "D MMM. 'YY, HH:mm"))}`}
    >
      <div className={Classes.statsContainer}>
        <span className={`${Classes.stat}`}>{t('listing.itemId', { itemId })}</span>
        <span className={Classes.stat}>
          <Icon name="eye-open" color="text-secondary" />
          <span className={Classes.summary}>{viewCount}</span>
        </span>

        <span className={Classes.stat}>
          <Icon name="heart" color="text-secondary" />
          <span className={Classes.summary}>{favoritedCount}</span>
        </span>

        <span className={Classes.stat}>
          <Icon name="clock" color="text-secondary" />
          <span className={Classes.summary}>
            <span className={Classes.dateExtra}>{`${t('stats.since')} `}</span>
            {date(new Date(since), "D MMM. 'YY, HH:mm")}
          </span>
        </span>
      </div>

      {!isAdOwner && (
        <div className={Classes.flaggingText}>
          <PopupLink itemId={itemId} />
        </div>
      )}
    </div>
  );
};

export default Report;
